import type { AuthorizedResourceAccessMap } from './adapter';

export const buildPermissionKey = (resourceCode: string, action?: string) =>
  action ? `${resourceCode}:${action}` : resourceCode;

export const hasResourceAccess = (
  access: AuthorizedResourceAccessMap | undefined,
  resourceCode: string,
) => Boolean(access?.[resourceCode]);

export const hasActionAccess = (
  access: AuthorizedResourceAccessMap | undefined,
  resourceCode: string,
  action: string,
) => Boolean(access?.[buildPermissionKey(resourceCode, action)]);
